<footer class="article-footer">
  <div class="article-footer__left">
    <!-- Tags -->
    <div class="article-footer__tags">
      @for (tag of post().tags; track tag.id) {
        <a
          class="article-footer__tag"
          [routerLink]="['/blog']"
          [queryParams]="{ tag: tag.slug }"
        >{{ tag.name }}</a>
      }
    </div>

    <!-- Share buttons (visible on mobile, hidden on desktop where TOC has them) -->
    <div class="article-footer__share">
      <button class="article-footer__share-btn" type="button" [attr.aria-label]="copy.shareTwitter" (click)="shareTwitter()">𝕏</button>
      <button class="article-footer__share-btn" type="button" [attr.aria-label]="copy.shareFacebook" (click)="shareFacebook()">f</button>
      <button class="article-footer__share-btn" type="button" [attr.aria-label]="copy.shareWhatsApp" (click)="shareWhatsApp()">WA</button>
      <button class="article-footer__share-btn" type="button" [attr.aria-label]="copied() ? copy.urlCopied : copy.copyUrl" (click)="copyUrl()">
        {{ copied() ? '✓' : '🔗' }}
      </button>
    </div>
  </div>

  <!-- Prev / Next navigation -->
  <nav class="article-footer__nav" [attr.aria-label]="copy.articleNavLabel">
    @if (prevPost()) {
      <a class="article-footer__nav-link article-footer__nav-link--prev" [routerLink]="['/blog', prevPost()!.slug]">
        <span class="article-footer__nav-label">{{ copy.prevArticle }}</span>
        <span class="article-footer__nav-title">{{ prevPost()!.title }}</span>
      </a>
    }
    @if (nextPost()) {
      <a class="article-footer__nav-link article-footer__nav-link--next" [routerLink]="['/blog', nextPost()!.slug]">
        <span class="article-footer__nav-label">{{ copy.nextArticle }}</span>
        <span class="article-footer__nav-title">{{ nextPost()!.title }}</span>
      </a>
    }
  </nav>
</footer>
